(() => {
  const STORAGE_KEY = 'adibelli_wishlist_v1';

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  const write = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
  };

  const isInWishlist = (id) => read().some((item) => String(item.id) === String(id));

  const toggle = (product) => {
    const items = read();
    const index = items.findIndex((item) => String(item.id) === String(product.id));
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift(product);
    }
    write(items);
    return index < 0;
  };

  const remove = (id) => {
    write(read().filter((item) => String(item.id) !== String(id)));
  };

  const syncButtons = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const id = button.getAttribute('data-product-id');
      const active = isInWishlist(id);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
      const outline = button.querySelector('.wishlist-button__icon--outline');
      const filled = button.querySelector('.wishlist-button__icon--filled');
      if (outline && filled) {
        outline.hidden = active;
        filled.hidden = !active;
      }
      const label = active
        ? (window.wishlistStrings && window.wishlistStrings.remove) || 'Von Merkliste entfernen'
        : (window.wishlistStrings && window.wishlistStrings.add) || 'Zur Merkliste';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  };

  const syncCounters = () => {
    const count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-count-label]').forEach((el) => {
      const template = (window.wishlistStrings && window.wishlistStrings.count) || '{{ count }} Artikel';
      el.textContent = template.replace('[count]', String(count)).replace('{{ count }}', String(count));
    });
  };

  const renderDrawer = () => {
    const list = document.querySelector('[data-wishlist-list]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!list || !empty) return;

    const items = read();
    list.innerHTML = '';

    if (!items.length) {
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    items.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'wishlist-drawer__item';
      li.innerHTML = `
        <a class="wishlist-drawer__media" href="${item.url}">
          ${item.image ? `<img src="${item.image}" alt="" width="120" height="150" loading="lazy">` : ''}
        </a>
        <div class="wishlist-drawer__meta">
          <a class="wishlist-drawer__title" href="${item.url}">${item.title}</a>
          <p class="wishlist-drawer__price">${item.price || ''}</p>
          <button type="button" class="button button--text wishlist-drawer__remove" data-wishlist-remove="${item.id}">
            ${(window.wishlistStrings && window.wishlistStrings.remove) || 'Entfernen'}
          </button>
        </div>
      `;
      list.appendChild(li);
    });
  };

  const openDrawer = () => {
    const details = document.querySelector('#Wishlist-Drawer');
    if (details) details.open = true;
    document.documentElement.classList.add('overflow-hidden');
    renderDrawer();
  };

  const closeDrawer = () => {
    const details = document.querySelector('#Wishlist-Drawer');
    if (details) details.open = false;
    document.documentElement.classList.remove('overflow-hidden');
  };

  document.addEventListener('click', (event) => {
    const toggleBtn = event.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      event.stopPropagation();
      const product = {
        id: toggleBtn.getAttribute('data-product-id'),
        handle: toggleBtn.getAttribute('data-product-handle'),
        url: toggleBtn.getAttribute('data-product-url'),
        title: toggleBtn.getAttribute('data-product-title'),
        price: toggleBtn.getAttribute('data-product-price'),
        image: toggleBtn.getAttribute('data-product-image'),
      };
      toggle(product);
      return;
    }

    const openBtn = event.target.closest('[data-wishlist-open]');
    if (openBtn) {
      event.preventDefault();
      openDrawer();
      return;
    }

    const closeBtn = event.target.closest('[data-wishlist-close]');
    if (closeBtn) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const removeBtn = event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      event.preventDefault();
      remove(removeBtn.getAttribute('data-wishlist-remove'));
    }
  });

  document.addEventListener('wishlist:updated', () => {
    syncButtons();
    syncCounters();
    renderDrawer();
  });

  const boot = () => {
    syncButtons();
    syncCounters();
    renderDrawer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.AdibelliWishlist = { read, write, toggle, remove, openDrawer, closeDrawer };
})();
